import { BrowserRouter, Link, Routes, Route } from "react-router-dom";
import BubbleSort from "./components/BubbleSort";
import SelectionSort from "./components/SelectionSort";
import InsertionSort from "./components/InsertionSort";
import Home from "./components/Home";
import { useState, useRef, useEffect } from "react";
import "font-awesome/css/font-awesome.min.css";
import "./App.css";

function App() {
  const windowSize = useRef([window.innerWidth, window.innerHeight]);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    console.log(windowSize.current[0]);
  });

  return (
    <BrowserRouter>
      <div className="App">
        <div className="app_header">
          <h1 className="header_text">Sorting Visualizer</h1>
        </div>
        <div className="app_container">
          <button className="toggle-button" onClick={handleToggle}>
            {sidebarOpen ? (
              <i className="fa fa-times" />
            ) : (
              <i className="fa fa-bars" />
            )}
          </button>
          <div
            className={`app_sidebar ${
              sidebarOpen || windowSize.current[0] >= 930 ? "open" : "closed"
            }`}
          >
            <li className="nav-item">
              <Link
                className="linkItem"
                to="/"
                onClick={() => {
                  setSidebarOpen(false);
                }}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="linkItem"
                to="/bubble-sort"
                onClick={() => {
                  setSidebarOpen(false);
                }}
              >
                Bubble Sort
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="linkItem"
                to="/selection-sort"
                onClick={() => {
                  setSidebarOpen(false);
                }}
              >
                Selection Sort
              </Link>
            </li>
            <li className="nav-item">
              <Link
                className="linkItem"
                to="/insertion-sort"
                onClick={() => {
                  setSidebarOpen(false);
                }}
              >
                Insertion Sort
              </Link>
            </li>
          </div>
          <div className="sort_container">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/bubble-sort" element={<BubbleSort />} />
              <Route path="/selection-sort" element={<SelectionSort />} />
              <Route path="/insertion-sort" element={<InsertionSort />} />
            </Routes>
          </div>
        </div>
        {/* <div className="app_footer">Footer</div> */}
      </div>
    </BrowserRouter>
  );
}

export default App;
